
import React, { useState, useEffect } from "react";
import { Button, Row, Col } from "reactstrap";
import { Form, Modal } from "react-bootstrap";
import captchImg from "../../assets/images/captchaImg.jpg";
import Slider from "react-slick";
import imageNotAvailable from "../../assets/img/Image_not_available.png"
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useNavigate, useLocation } from "react-router-dom";
import axiosConn from "config/axiosConn";
import { jwtDecode } from "jwt-decode";
import SideBar from "./SideBar";
import Langfield from "../../assets/Json/accountFormLang.json";
import Helper from "../../helper/Common_Helper";
import { changeLang, voiceSelected } from "../../redux/langSlice";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import StateList from "../../helper/State_List.json";
import DistrictList from "../../helper/District_List.json";

function RasActivitiesList() {
  const navigate = useNavigate();
  const location = useLocation();
  const [modalShow, setModalShow] = useState(false);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [activitiesList, setActivitiesList] = useState([]);
  const [statusValue, setStatus] = useState(1);
  const [role, setRole] = useState("");
  const [auther, setAuther] = useState("");
  const [mediaUrl, setMediaUrl] = useState("");
  const [isVideo, setIsVideo] = useState(false);
  const [voiceSelected, setVoiceSelected] = useState("");
  const [udise_id, setUDISE] = useState("");
  const [username, setUserName] = useState("");
  const [email, setEmail] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [initialValues, setInitialValues] = useState({
    udise_id: "",
  });
  const userData = useSelector(state => state.auth.user);
  const langSelected = userData.lang;
  const dispatch = useDispatch();
  const translations = Langfield[langSelected];

  const readOnlySasToken = "sp=racwl&st=2025-04-01T07:46:42Z&se=2025-07-31T15:46:42Z&spr=https&sv=2024-11-04&sr=c&sig=w%2BL9zU%2Fp35vjnI5P1Aghw%2B%2BB1zMW%2B7lI6XkGMPNhCD0%3D";

  const translate = (key) => {
    // Check if translations is defined and is an object
    if (typeof translations !== "object" || translations === null) {
      return key; // Return the key if translations is not available
    }

    // Handle undefined or non-string keys
    if (typeof key !== "string") {
      return key; // Return the value as is if key is not a string
    }

    return translations[key] || key.replace(/_/g, " "); // Use translation or fallback to the key
  };

  // Helper function to get district name from district ID
  const getDistrictName = (districtId) => {
    if (!districtId) return "";
    
    // Handle both string and number district IDs
    const district = DistrictList.find(d => d.district_id == districtId);
    return district ? district.district_name : districtId;
  };

  // Helper function to get state name from state ID
  const getStateName = (stateId) => {
    if (!stateId) return "";
    
    // Handle both string and number state IDs
    const state = StateList.find(s => s.state_id == stateId);
    return state ? state.state_name : stateId;
  };

  useEffect(() => {
    if (userData) {
      setRole(userData.role);
      setUDISE(userData.udise_id);
      setInitialValues({
        ...initialValues,
        ["udise_id"]: userData.udise_id,
      });
      setAuther(userData?.email ? userData?.email : "Principal");
      if (userData.role === 2) {
        getRasActivitiesList({
          udise_id: userData.udise_id,
          isdeleted: false,
          status: statusValue,
        });
      } else {
        setEmail(userData.email);
        getFacultyRasActivitiesList({
          udise_id: userData.udise_id,
          email: userData.email,
          status: statusValue,
        });
      }
    } else {
      navigate("/");
    }
  }, [userData, location.key]); // Added location.key to refetch data on navigation

  const handleChanges = (val) => {
    setStatus(val);
    if (role === 2) {
      getRasActivitiesList({ udise_id: udise_id, isdeleted: false, status: val });
    } else {
      getFacultyRasActivitiesList({
        udise_id: udise_id,
        email: email,
        isdeleted: false,
        status: val,
      });
    }
  };

  const getRasActivitiesList = async (data, page = 1) => {
    try {
      data["page"] = page;
      data["limit"] = 9;
      const response = await axiosConn("post", `get-ras-activities`, data, {}, dispatch);
      if (response.data.status === "success") {
        if (response.data.data.length > 0) {
          setActivitiesList(response.data.data);
          setTotalPages(response.data.totalPages);
          setCurrentPage(response.data.currentPage);
        } else {
          setActivitiesList([]);
        }
      } else {
        setActivitiesList([]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
      if (role === 2) {
        getRasActivitiesList({ udise_id, isdeleted: false, status: statusValue }, page);
      } else {
        getFacultyRasActivitiesList(
          {
            udise_id: udise_id,
            isdeleted: false,
            email: email,
            status: statusValue,
          },
          page
        );
      }
    }
  };

  const getRasActivityById = async (id) => {
    try {
      const response = await axiosConn("get", `get-ras-activity/${id}`);
      if (response.data.status === "success") {
        return response.data.data;
      } else {
        console.error("RAS Activity not found");
        return null;
      }
    } catch (error) {
      console.error("Error fetching RAS activity by ID:", error);
      return null;
    }
  };

  const getFacultyRasActivitiesList = async (data, page = 1) => {
    try {
      data["page"] = page;
      data["limit"] = 9;
      const response = await axiosConn(
        "post",
        `get-faculty-ras-activities`,
        data
      );
      if (response.data.status === "success") {
        if (response.data.data.length > 0) {
          setActivitiesList(response.data.data);
          setTotalPages(response.data.totalPages);
          setCurrentPage(response.data.currentPage);
        } else {
          setActivitiesList([]);
        }
      } else {
        setActivitiesList([]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const updateRasActivity = async (data) => {
    try {
      data["auther"] = auther;
      const response = await axiosConn("post", `update-ras-activity-status`, data);
      if (response.data.status === "success") {
        if (role === 2) {
          getRasActivitiesList({
            udise_id: udise_id,
            isdeleted: false,
            status: statusValue,
          });
        } else {
          getFacultyRasActivitiesList({
            udise_id: udise_id,
            email: email,
            isdeleted: false,
            status: statusValue,
          });
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const handleMediaClick = (url, type) => {
    setMediaUrl(url);
    setIsVideo(type === "video");
    setModalShow(true);
  };

  const handleEditClick = async (item) => {
    const activityDetails = await getRasActivityById(item._id);
    if (activityDetails) {
      navigate("/school/ras-activities", {
        state: { item: activityDetails },
      });
    }
  };

  // Helper function to format activity type (supports multiple comma-separated types)
  const formatActivityType = (type) => {
    if (!type) return "";
    const activityTypes = {
      awareness: "Awareness Campaign",
      sitevisit: "Site Visit",
      recharge: "Water Recharge Activity"
    };
    // Handle multiple activity types separated by comma
    const types = type.split(',').map(t => t.trim());
    return types.map(t => activityTypes[t] || t).join(", ");
  };

  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Report an Image</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="reportImgDiv">
            <form action="">
              <div className="form-group">
                <label htmlFor="">Remarks</label>
                <textarea
                  name=""
                  id=""
                  cols="30"
                  rows="10"
                  className="form-control"
                ></textarea>
              </div>
              <div className="form-group">
                <label htmlFor="">Security Pin</label>
                <img src={captchImg} alt="" />
              </div>
            </form>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            className="button green btn-login-signup loginBtnnewhm reprtBtn"
            onClick={handleClose}
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>

      <section className="scholdashbrdSec eventListSecnew">
        <SideBar langSelected={langSelected} index={11} role={role} />

        <div className="schlDashbrdRgt">
          <div class="row justify-content-center">
            <div class="col-md-12">
              <div class="card-user pageContainer">
                <div class="card-header pgHederSpceArnd">
                  <h5 class="card-title">{translate("RAS Activities List")}</h5>
                </div>
                <div className="">
                  <div className="container">
                    <Row>
                      <Col md="12">
                        <div className="d-flex justify-content-center w-100 mb-4">
                          <div
                            className="d-flex justify-content-start mr-5"
                            style={{ marginRight: "15px" }}
                          >
                            <Form.Check
                              name="status"
                              value="1"
                              style={{ marginRight: "5px" }}
                              type="radio"
                              defaultChecked
                              onClick={() => handleChanges(1)}
                            ></Form.Check>
                            <Form.Label className="ml-2">
                              {translate("Pending")}
                            </Form.Label>
                          </div>
                          <div
                            className="d-flex justify-content-start mr-5"
                            style={{ marginRight: "15px" }}
                          >
                            <Form.Check
                              name="status"
                              value="2"
                              style={{ marginRight: "5px" }}
                              type="radio"
                              onClick={() => handleChanges(2)}
                            ></Form.Check>
                            <Form.Label className="ml-2">
                              {translate("Approved")}
                            </Form.Label>
                          </div>
                          <div
                            className="d-flex justify-content-start mr-5"
                            style={{ marginRight: "15px" }}
                          >
                            <Form.Check
                              name="status"
                              value="0"
                              style={{ marginRight: "5px" }}
                              type="radio"
                              onClick={() => handleChanges(0)}
                            ></Form.Check>
                            <Form.Label className="ml-2">
                              {translate("Rejected")}
                            </Form.Label>
                          </div>
                        </div>
                      </Col>
                      {activitiesList && activitiesList.filter(item => {
                        // Support both single and multiple comma-separated activity types
                        const activityTypes = item.activity_type ? item.activity_type.split(',').map(a => a.trim()) : [];
                        return activityTypes.some(type => ['awareness', 'sitevisit', 'recharge'].includes(type));
                      }).length > 0 ? (
                        activitiesList
                          .filter(item => {
                            // Support both single and multiple comma-separated activity types
                            const activityTypes = item.activity_type ? item.activity_type.split(',').map(a => a.trim()) : [];
                            return activityTypes.some(type => ['awareness', 'sitevisit', 'recharge'].includes(type));
                          })
                          .map((item, i) => {
                          // Collect media from various activity types
                          const media = [];
                          
                          // Add awareness campaign photos
                          if (item.awareness?.lecturePhoto && item.awareness.lecturePhoto.length > 0) {
                            item.awareness.lecturePhoto.forEach(photo => {
                              media.push({ type: "image", url: photo.file });
                            });
                          }
                          if (item.awareness?.seminarPhoto && item.awareness.seminarPhoto.length > 0) {
                            item.awareness.seminarPhoto.forEach(photo => {
                              media.push({ type: "image", url: photo.file });
                            });
                          }
                          
                          // Add site visit photo
                          if (item.sitevisit?.photo && Array.isArray(item.sitevisit.photo)) {
                            item.sitevisit.photo.forEach(photo => {
                              if (photo && photo.file) {
                                media.push({ type: "image", url: photo.file });
                              }
                            });
                          }
                          
                          // Add recharge photos (now an array)
                          if (item.recharge?.rechargePhoto && Array.isArray(item.recharge.rechargePhoto)) {
                            item.recharge.rechargePhoto.forEach(photo => {
                              if (photo && photo.file) {
                                media.push({ type: "image", url: photo.file });
                              }
                            });
                          }

                          const getSecurePhotoUrl = (photoUrl) => {
                            if (!photoUrl) return imageNotAvailable;
                            const baseUrl = photoUrl.split('?')[0];
                            return `${baseUrl}?sp=r&st=2026-02-06T06:00:58Z&se=2026-12-31T14:15:58Z&spr=https&sv=2024-11-04&sr=c&sig=n4zcC%2FICuzy6IgQ62mGtREv%2FQI3HUeu2TFULEdZkDyI%3D`;
                          };

                          const securePhotoUrl = media.length > 0 ? getSecurePhotoUrl(media[0].url) : imageNotAvailable;

                          return (
                            <Col md="4" key={i}>
                              <div className="viewThemeDiv">
                                <div className="flip-card">
                                  <div className="flip-card-inner">
                                    <div className={`${media.length > 0 ? 'flip-card-front2' : 'flip-card-front'}`}>
                                      <div className="flip-card-front-in">
                                        <img
                                          src={securePhotoUrl}
                                          alt="Activity Image"
                                        />
                                        <div className="frontThemName">
                                          <h1>
                                            {translate("Activity Type")} :
                                            <strong> 
                                              {formatActivityType(item.activity_type)}
                                            </strong>
                                          </h1>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="flip-card-back">
                                      <div className="flipCardBackIn">
                                        <h1>
                                          {translate("School Name")} :
                                          <strong>
                                            {item.school_name ? item.school_name : ""}
                                          </strong>
                                        </h1>
                                        <h1>
                                          {translate("UDISE ID")}:
                                          <strong>
                                            {item.udise_id ? item.udise_id : ""}
                                          </strong>
                                        </h1>
                                        <h1>
                                          {translate("Activity Type")}:
                                          <strong>
                                            {formatActivityType(item.activity_type)}
                                          </strong>
                                        </h1>
                                        <h1>
                                          {translate("School Type")}:
                                          <strong>
                                            {item.school_type ? item.school_type : ""}
                                          </strong>
                                        </h1>
                                        <h1>
                                          {translate("PM SHRI")}:
                                          <strong>
                                            {item.pm_shri ? item.pm_shri : ""}
                                          </strong>
                                        </h1>
                                        <h1>
                                          {translate("State")}:
                                          <strong>
                                            {getStateName(item.state) || item.state || ""}
                                          </strong>
                                        </h1>
                                        <h1>
                                          {translate("District")}:
                                          <strong>
                                            {getDistrictName(item.district) || item.district || ""}
                                          </strong>
                                        </h1>
                                        <h1>
                                          {translate("City")}:
                                          <strong>
                                            {item.city ? item.city : ""}
                                          </strong>
                                        </h1>
                                        <h1>
                                          {translate("Principal Name")}:
                                          <strong>
                                            {item.principal_name ? item.principal_name : ""}
                                          </strong>
                                        </h1>
                                        <h1>
                                          {translate("Locality")}:
                                          <strong>
                                            {item.locality ? item.locality : ""}
                                          </strong>
                                        </h1>
                                        {/* Check if activity_type includes 'awareness' (supports multiple types) */}
                                        {item.activity_type && item.activity_type.includes("awareness") && (
                                          <>
                                            {item.awareness?.lectureConducted === "yes" && (
                                              <h1>
                                                {translate("Lecture Conducted")}:
                                                <strong> Yes</strong>
                                              </h1>
                                            )}
                                            {item.awareness?.seminarConducted === "yes" && (
                                              <h1>
                                                {translate("Seminar Topic")}:
                                                <strong> {item.awareness?.seminarTopic || ""}</strong>
                                              </h1>
                                            )}
                                          </>
                                        )}
                                        {/* Check if activity_type includes 'sitevisit' (supports multiple types) */}
                                        {item.activity_type && item.activity_type.includes("sitevisit") && item.sitevisit && (
                                          <>
                                            <h1>
                                              {translate("Site Type")}:
                                              <strong> {item.sitevisit.siteType || ""}</strong>
                                            </h1>
                                            <h1>
                                              {translate("Site Name")}:
                                              <strong> {item.sitevisit.siteName || ""}</strong>
                                            </h1>
                                          </>
                                        )}
                                        {/* Check if activity_type includes 'recharge' (supports multiple types) */}
                                        {item.activity_type && item.activity_type.includes("recharge") && item.recharge && (
                                          <>
                                            <h1>
                                              {translate("Recharge Type")}:
                                              <strong> {item.recharge.type || ""}</strong>
                                            </h1>
                                            <h1>
                                              {translate("Location")}:
                                              <strong> {item.recharge.location || ""}</strong>
                                            </h1>
                                            <h1>
                                              {translate("Volume")}:
                                              <strong> {item.recharge.volume || ""} cubic meters</strong>
                                            </h1>
                                          </>
                                        )}
                                        <h1>
                                          {translate("Submitted At")}:
                                          <strong>
                                            {item.submittedAt
                                              ? Helper.formatDate(item.submittedAt)
                                              : ""}
                                          </strong>
                                        </h1>
                                      </div>
                                    </div>
                                  </div>

                                  {media.length > 0 && (
                                    <div className="themCarslDiv">
                                      <Slider {...settings}>
                                        {media.map((mediaItem, j) => (
                                          <div className="slide01newnew" key={j}>
                                            <div
                                              className="btn-login-signup"
                                              onClick={() =>
                                                handleMediaClick(
                                                  getSecurePhotoUrl(mediaItem.url),
                                                  mediaItem.type
                                                )
                                              }
                                            >
                                              {mediaItem.type === "image" ? (
                                                <img
                                                  src={getSecurePhotoUrl(mediaItem.url)}
                                                  alt="Activity Media"
                                                />
                                              ) : (
                                                <video
                                                  style={{
                                                    width: "100%",
                                                    height: 71,
                                                  }}
                                                >
                                                  <source
                                                    src={getSecurePhotoUrl(mediaItem.url)}
                                                    type="video/mp4"
                                                  />
                                                  Your browser does not support the video tag.
                                                </video>
                                              )}
                                            </div>
                                          </div>
                                        ))}
                                      </Slider>
                                    </div>
                                  )}
                                  
                                  {statusValue === 1 ? (
                                    <div className="actionBtn">
                                      <Button
                                        variant="primary"
                                        onClick={() => handleEditClick(item)}
                                        className="btn-round btn btn-primary apprvBtn mr-3"
                                      >
                                        {translate("Edit")}
                                      </Button>

                                      {/* Check if item has media before rendering the "Approve" button */}
                                      {(media.length > 0 && role !== 3) && (
                                        <Button
                                          variant="primary"
                                          onClick={() =>
                                            updateRasActivity({
                                              id: item._id,
                                              status: 2,
                                            })
                                          }
                                          className="btn-round btn btn-primary editBtn mr-3"
                                        >
                                          {translate("Approve")}
                                        </Button>
                                      )}
                                      {(media.length > 0 && role !== 3) && (
                                        <Button
                                          variant="primary"
                                          onClick={() =>
                                            updateRasActivity({
                                              id: item._id,
                                              status: 0,
                                            })
                                          }
                                          className="btn-round btn btn-primary btnDelete mr-3"
                                        >
                                          {translate("Reject")}
                                        </Button>
                                      )}
                                    </div>
                                  ) : (
                                    <div className="actionBtn">
                                      <Button
                                        variant="primary"
                                        className="btn-round btn btn-primary apprvBtn mr-3"
                                      >
                                        {item.status === 2
                                          ? translate("Approved")
                                          : item.status === 0
                                          ? translate("Rejected")
                                          : ""}
                                      </Button>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </Col>
                          );
                        })
                      ) : (
                        <p className="text-center">No RAS activities found.</p>
                      )}
                    </Row>
                    {totalPages > 1 ? (
                      <div className="mb-3 text-center">
                        <button
                          onClick={() => handlePageChange(currentPage - 1)}
                          disabled={currentPage === 1}
                        >
                          {translate("Previous")}
                        </button>
                        <span>
                          {`Page ${currentPage} of ${totalPages}`}
                        </span>
                        <button
                          onClick={() => handlePageChange(currentPage + 1)}
                          disabled={currentPage === totalPages}
                        >
                          {translate("Next")}
                        </button>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <MyVerticallyCenteredModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        mediaUrl={mediaUrl}
        isVideo={isVideo}
        setModalShow={(value) => {
          setModalShow(value);
        }}
      />
    </>
  );
}

export default RasActivitiesList;

function MyVerticallyCenteredModal(props) {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <span onClick={() => props.setModalShow(false)} className="closebtn">
        X
      </span>
      <Modal.Body style={{ padding: 20 }}>
        {props.isVideo ? (
          <video controls style={{ width: "100%", height: 500 }}>
            <source src={props.mediaUrl} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        ) : (
          <img src={props.mediaUrl} alt="" style={{ width: "100%" }} />
        )}
      </Modal.Body>
    </Modal>
  );
}
